import React from 'react'

const RedoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
    <path
      d='M 17 1.875 L 17 5 L 9 5 C 4.053124 5 0 9.053124 0 14 C 0 18.946876 4.053124 23 9 23 L 24 23 L 24 19 L 9 19 C 6.214876 19 4 16.785124 4 14 C 4 11.214876 6.214876 9 9 9 L 17 9 L 17 12.125 L 24 7 L 17 1.875 z'
      fill='currentcolor'
    />
  </svg>
)

export default RedoIcon
